import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { ServerOption } from '../models/server-option';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { serverOptionSelectors } from '../state/server-option.reducer';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: ServerSelectComponent,
        },
    ],
    selector: 'ndt-server-select',
    templateUrl: './server-select.component.html',
    standalone: false
})
export class ServerSelectComponent extends LcsSingleSelectBase<ServerOption> implements OnInit {

  servers: Observable<ServerOption[] | null>;

  constructor(
    protected elementRef: ElementRef,
    protected changeDetectorRef: ChangeDetectorRef,
    protected viewContainerRef: ViewContainerRef,
    private store: Store
  ) {
    super(elementRef, changeDetectorRef, viewContainerRef);
  }

  ngOnInit(): void {
    this.servers = this.store.pipe(select(serverOptionSelectors.selectFilteredItems), this.itemsLoaded());
  }

  displayWith(item: ServerOption | null): string | null {
    return item ? item.serverName : null;
  }

  trackBy(item: ServerOption | null) {
    return item ? item.serverId : null;
  }

}
